import React, { Component } from 'react';
import _ from "lodash";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form'
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './ongroundchallenge.css';
import data from './data'
import CricketFrom from './components/form'
import kiranMorePic from '../src/images/kiran-more-pic.png'
import OnGroundChallengePic from '../src/images/on-ground-challenge-pic.png'

import heroOnground1 from '../src/images/hero-onground-1.png';

import WinPrizes from './components/WinPrizes';
import VideoSlider from './components/VideoSlider';
import Header from './components/Header';

import formGraphic from '../src/images/form-graphic.png';
import logo from '../src/images/logo.png';
import logoPuyd from '../src/images/logo-puyd.png';

class OnGroundChallenge extends Component {
  
  constructor(props) {
    super(props);
    var categories = _.uniq(_.map(_.filter(data), "category"));
    this.state = {
      category: categories[0],
      data: _.filter(data, { category: categories[0] }),
      categories: categories,
    };
    this.myRef = React.createRef()  

    
  }
  updatePage(e, category) {
    var catgry = category ? category : e.target.value;
    var categories = _.uniq(_.map(_.filter(data), "category"));
    this.setState({
      category: catgry,
      data: _.filter(data, { category: catgry }),
      categories: categories,
    });
    e.preventDefault();
  }

  render() {

    return (
      <div>
        <Helmet>
          <title>On-Ground Challenge | Gulf Oil India</title>
          <meta name="description" content="Pick Up Your Dream and take the on-ground challenge now. Stand a chance to win the dream prize! Excited? Participate today!" />
        </Helmet>
        <section className="generic-padding hero-online-wrapper">
          <Container>
            <Header />
            <Row className="align-items-center">
              <Col md={12} lg={7}>
                <div className="text-center text-lg-left">
                  <img src={heroOnground1} className="img-fluid" alt="Gulf Oil India" />
                  <p className="my-4 font-weight-bold"><em>If you are a serious cricketer and dream of being coached by <br className="d-none d-sm-block" />
                    <span className="text-orange">two of India’s finest cricketers,</span> then don’t miss this!</em></p>
                </div>
              </Col>
              <Col md={{ span: 8, offset: 2 }} lg={{ span: 5, offset: 0 }} className="align-bottom">
                <div className="video-thumb-wrapper video-slider video-onground">
                  <VideoSlider />
                  <div className="video-bg-texture"></div>
                  <div className="video-bg-texture video-bg-texture-2"></div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="hero-online-mask"></div>
        </section>
        <section className="generic-padding onground-mid-wrapper">
          <Container>
            <h2 className="sub-title sub-title-orange text-center">TAKE THE ON-GROUND CHALLENGE</h2>
            <Row className="mb-4 mt-5 align-items-center no-gutters">
              <Col lg={6} className="font-italic">
                <h3 className="text-uppercase font-weight-bold">Pick Up Your Dream and take <br className="d-none d-sm-block" />
                  <span className="text-orange">the on-ground challenge NOW!</span></h3>
                <div className="font-size-6">
                  <p className="text-orange">ALL YOU HAVE TO DO :</p>
                  <p>STEP 1: Choose a city where you would like to take
                the challenge and <a href="#" onClick={this.scrollToMyRef}>fill the registration form</a></p>
                  <p>STEP 2: Show up for the trial with your Gulf Pride can
                and your registration form</p>
                  <p>STEP 3: Participate in the trials and showcase
                your best to our selectors</p>
                </div>
              </Col>
              <Col lg={6} className="text-center">
                <img src={OnGroundChallengePic} className="img-fluid" alt="" />
              </Col>
            </Row>
            <WinPrizes />
            <Row className="d-flex h-100">
              <Col lg={7}>
                <img src={kiranMorePic} alt="OUR CHIEF SELECTOR" className="img-fluid" />
              </Col>
              <Col lg={5} className="justify-content-center align-self-center">
                <h2 className="addHeading">OUR CHIEF SELECTOR</h2>
                <p className="font-size-6"><em>To identify the best, you need the best! We are happy to have on board Mr. Kiran More, who needs no introduction. A former Indian cricketer and
also former Chairman of the Selection Committee of the BCCI.</em></p>
              </Col>
            </Row>
          </Container>
          <div className="onground-mid-mask"></div>
        </section>
        <section className="map-wrapper">
          <Container>
            <Row className="mb-3">
              <Col lg={7} className="d-none d-lg-block">
                <div className="india-map-wrapper">
                  <div className="india-map">
                    <div className="text-center inner-tab-link pointer">
                      {this.state.categories.map((category, i) => { return <a href="#" key={i} onClick={(e) => this.updatePage(e, category)} className={category}><span className={this.state.category == category ? 'active' : ''}>{category}</span></a> })}
                    </div>
                  </div>
                  <div className="india-map-bg"></div>
                </div>
              </Col>
              <Col lg={5}>
                <h2 className="addHeading mb-5">excited?<br />mark the dates<span>BE THERE AND SHOW YOUR TALENT</span></h2>
                <div className="d-block d-lg-none">
                  <div className="selCity">
                    <Form>
                      <Form.Group controlId="exampleForm.ControlSelect1" onChange={(e) => this.updatePage(e, this.category)}>
                        <Form.Label></Form.Label>
                        <Form.Control as="select">
                          {this.state.categories.map((category, i) => <option key={i}>{category}</option>)}
                        </Form.Control>
                      </Form.Group>
                    </Form>
                  </div>
                </div>
                {this.state.data.map((item, i) => (
                  <div className="addBg" key={i}>
                    <div className="addressBx">
                      <p className="location">Location: {item.location}</p>
                      {item.addresses.map((item, i) => (
                        <p key={i} dangerouslySetInnerHTML={{ __html: item.adress }} className="fullAdd"></p>
                      ))}
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Container>
          <div className="onground-map-mask"></div>
        </section>
        <section className="generic-padding onground-btm-wrapper"  ref={this.myRef}>
          <Container>
            <h2 className="sub-title sub-title-orange text-center"><span className="sub-title-normal">11 lucky winners get a chance to learn cricket from</span><br />
              M.S. Dhoni and Hardik Pandya!</h2>
            <Row>
              <Col lg="4 text-center">
                <div className="px-5">
                  <Row className="align-items-end">
                    <Col xs={{ span: 5, offset: 1 }}>
                      <img src={logo} alt="Gulf Oil India" className="align-bottom img-fluid" />
                    </Col>
                    <Col xs={6}>
                      <img src={logoPuyd} alt="Pick-up Your Dream" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <img src={formGraphic} alt="Gulf Oil India" className="img-fluid text-right" />
              </Col>
              <Col lg="8">
                <div className="register pb-5">
                  <h3>Calling all those who are between 16 to 23 years of age.<br />
                    Register now and get ready for the battle!</h3>
                </div>
                <CricketFrom />
                <ol className="font-15 pl-3 mt-5 font-italic">
                  <li>Participants need to be between the ages of 16 to 23 years</li>
                  <li>Participants who are 16 or 17 years of age will need to be accompanied by parents/local guardians</li>
                  <li>Only Aadhar Cards will be accepted as age proof</li>
                  <li>Participants who have a kits can bring the same for the try-outs</li>
                  <li>All participants to report at the venue at 7:30 AM</li>
                </ol>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
  scrollToMyRef = (e) => {
    e.preventDefault();
    window.scrollTo(1000, this.myRef.current.offsetTop)
  }
}
export default OnGroundChallenge;